import React from 'react'
import { makeStyles, Paper, Typography } from '@material-ui/core'

export const FIELD_GAP = 12
export const BUTTON_WIDTH = 160
export const SECTION_PADDING = 16
export const HALVES_GAP = 24

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        minHeight: 36,
        marginBottom: theme.spacing(1),
    },
    paper: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        overflow: 'hidden',
        padding: theme.spacing(2, 2, 2.5),
    },
    dense: {
        padding: 0,
    },
}))

interface Props {
    title: React.ReactNode
    action?: React.ReactNode
    dense?: boolean
    plain?: boolean
    children: React.ReactNode
}

export default function DashboardSection({ title, action, dense = false, plain = false, children }: Props) {
    const classes = useStyles()
    return (
        <section className={classes.root}>
            <div className={classes.header}>
                <Typography variant="h6">{title}</Typography>
                {action ?? null}
            </div>
            {plain ? children : <Paper className={`${classes.paper} ${dense ? classes.dense : ''}`}>{children}</Paper>}
        </section>
    )
}
